import { defineComponent as a, computed as o, openBlock as c, createElementBlock as i, createElementVNode as e, toDisplayString as d, createCommentVNode as f, normalizeStyle as _ } from "vue";
const h = ["viewBox"], u = /* @__PURE__ */ e("mask", { id: "08f07495-8b75-43a7-8cfb-e309150cdf51" }, [
  /* @__PURE__ */ e("circle", {
    cx: "256",
    cy: "256",
    r: "256",
    fill: "#fff"
  })
], -1), m = { mask: "url(#08f07495-8b75-43a7-8cfb-e309150cdf51)" }, p = { key: 0 }, k = /* @__PURE__ */ e("path", {
  fill: "#338af3",
  d: "M0 0h512v512H0z"
}, null, -1), g = /* @__PURE__ */ e("path", {
  fill: "#eee",
  d: "M161.4 345h189.2L256 122.4z"
}, null, -1), v = /* @__PURE__ */ e("path", {
  fill: "#333",
  d: "M194.3 322.8 256 182.4l61.7 140.4z"
}, null, -1), x = /* @__PURE__ */ e("path", {
  fill: "#ffda44",
  d: "M161.4 345h189.2L256 256z"
}, null, -1), w = { fill: "none" }, y = ["r"], N = /* @__PURE__ */ a({
  __name: "lc",
  props: {
    flagName: {},
    strokeColor: { default: "#000" },
    strokeWidth: { default: 0 }
  },
  setup(n) {
    const t = n, l = o(() => 512 + 2 * t.strokeWidth), s = o(() => -t.strokeWidth), r = o(() => 256 + t.strokeWidth / 2);
    return (z, W) => (c(), i("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "svg-circle-flags",
      viewBox: `${s.value} ${s.value} ${l.value} ${l.value}`
    }, [
      u,
      e("g", m, [
        t.flagName ? (c(), i("title", p, d(t.flagName), 1)) : f("", !0),
        k,
        g,
        v,
        x
      ]),
      e("g", w, [
        e("circle", {
          cx: "256",
          cy: "256",
          r: r.value,
          fill: "none",
          style: _({ stroke: t.strokeColor, strokeWidth: t.strokeWidth })
        }, null, 12, y)
      ])
    ], 8, h));
  }
});
export {
  N as default
};
//# sourceMappingURL=lc-c7e7ad17.js.map
